module.exports = __webpack_public_path__ + "img/voice_2.b7697a38.svg";